import { useState } from 'react'
import { Button } from 'shared/ui/Button'
import { ColorEnum } from 'shared/ui/Button/ui/Button'
import { FullscreenDialog } from 'shared/ui/FullscreenDialog'
import { isStandalonePwa } from 'shared/lib/isStandalonePwa/isStandalonePwa'
import { ExportIcon } from 'shared/ui/Icon'
import installInstruction from 'shared/assets/install.png'
import cls from './ProfileInstallBanner.module.scss'

export const IosInstallGuideDialog = ({ open, onOpenChange }) => (
    <FullscreenDialog
        label="Как установить MineCards"
        onOpenChange={onOpenChange}
        open={open}
    >
        <div className={cls.DialogContent}>
            <div className={cls.InstructionImageContainer}>
                <img
                    alt="Пункт На экран Домой в меню браузера"
                    className={cls.InstructionImage}
                    src={installInstruction}
                />
            </div>
            <div className={cls.Copy}>
                <h2 className={cls.Title}>Установить MineCards легко!</h2>
                <p className={cls.Description}>
                    Нажми <strong>Поделиться</strong>{' '}
                    <ExportIcon className={cls.ShareIcon} size={24} /> в меню
                    браузера и выбери <strong>На экран «Домой»</strong>
                </p>
            </div>
        </div>
    </FullscreenDialog>
)

export const ProfileInstallBanner = ({
    installPrompt,
    onInstallPromptHandled,
    platform,
}) => {
    const [iosDialogOpen, setIosDialogOpen] = useState(false)
    const [androidPromptConsumed, setAndroidPromptConsumed] = useState(false)

    const canInstallOnAndroid =
        platform === 'android' &&
        !androidPromptConsumed &&
        typeof installPrompt?.prompt === 'function'
    const canExplainIosInstall = platform === 'ios'

    if (isStandalonePwa() || (!canInstallOnAndroid && !canExplainIosInstall)) {
        return null
    }

    const openInstaller = async () => {
        if (canExplainIosInstall) {
            setIosDialogOpen(true)
            return
        }

        setAndroidPromptConsumed(true)
        try {
            await installPrompt.prompt()
            await installPrompt.userChoice
        } catch (error) {
            console.error('Не удалось открыть установку MineCards', error)
        } finally {
            onInstallPromptHandled?.()
        }
    }

    return (
        <>
            <section className={cls.Banner}>
                <div className={cls.BannerText}>В приложении удобнее!</div>
                <Button
                    ariaLabel="Установить MineCards"
                    className={cls.BannerButton}
                    color={ColorEnum.BLUE}
                    onClick={openInstaller}
                    text="Установить"
                />
            </section>
            {canExplainIosInstall ? (
                <IosInstallGuideDialog
                    onOpenChange={setIosDialogOpen}
                    open={iosDialogOpen}
                />
            ) : null}
        </>
    )
}
